import { Breadcrumb, Link } from "@/atoms"
import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { HeaderPage } from "@/organisms/HeaderPage"
import { FormDockerHub } from "@/pages/IntegrationsPage/components/molecules/FormDockerHub"
import { useDockerHubAPI } from "@/pages/IntegrationsPage/hooks/useDockerHubAPI"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { PageWithBreadcrumbTemplate } from "@/templates/PageWithBreadcrumbTemplate"
import { ConnectIntegrationFooter } from "../ConnectIntegrationPage/ConnectIntegrationFooter"

import styles from "./DockerHubIntegrationPage.module.scss"

export const DockerHubIntegrationPage = () => {
  const { t } = useTranslation()
  const vendor = INTEGRATION_VENDORS.dockerHub
  const [_, { onRemove: _onRemove, ...formProps }] = useIntegration({ vendor })
  const dockerHubApi = useDockerHubAPI(formProps)
  const title = t("integrations.dockerHub.title")

  return (
    <PageWithBreadcrumbTemplate
      full
      header={
        <HeaderPage
          title={
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link to="/integrations">
                      {t("navigation.integrations")}
                    </Link>
                  )
                },
                {
                  title: (
                    <Link to={formProps.getBackToIntegrationUrl()}>
                      Docker Hub
                    </Link>
                  )
                },
                { title }
              ]}
            />
          }
        />
      }
      footer={
        <ConnectIntegrationFooter
          disabled={!formProps.isDirty}
          isLoading={dockerHubApi.isPending}
          okText={t("integrations.dockerHub.form.buttons.connect")}
          okProps={{ form: dockerHubApi.formId, htmlType: "submit" }}
          onCancel={() => formProps.backToIntegration()}
        />
      }
    >
      <div className={styles.title}>
        <Heading level={4} title={title} />
        <Heading level={6} title={t("integrations.dockerHub.form.title")} />
      </div>
      <FormDockerHub
        formId={dockerHubApi.formId}
        onFinish={dockerHubApi.onFinish}
        {...formProps}
      />
    </PageWithBreadcrumbTemplate>
  )
}
